import useSWR from "swr";
import Link from "next/link";
import { formatMarkdown } from "@/components/formatMarkdown";
import { Template } from "@/types/template";

export const Templates2 = ({ limit = 6 }: { limit?: number }) => {
  const { data: templates } = useSWR<Template[]>(
    `/api/template?sort=popular&limit=${limit}&tag=template`
  );

  return (
    <section id="templates" className="max-w-[1140px] mx-auto px-8 py-24">
      <div className="max-w-[720px] mx-auto text-center mb-14">
        <div className="inline-block text-xs text-primary bg-primary/8 px-3 py-1 rounded-full mb-4 font-medium tracking-wide lowercase font-mono">
          one-click templates
        </div>
        <h2 className="font-serif text-[clamp(36px,5.5vw,56px)] leading-[1.05] tracking-tight font-normal mb-4 text-foreground text-balance">
          Or skip the build —
          <br />
          <em className="text-primary">fork a template.</em>
        </h2>
        <p className="text-[17px] leading-relaxed text-muted-foreground text-pretty">
          Ready-made starter projects and self-hostable apps. Fork, deploy, done.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {templates?.map(t => (
          <a
            key={t.id}
            href={`/r/${t.id}`}
            className="plausible-event-name=L2_TemplateClicked bg-card border rounded-xl overflow-hidden shadow-sm hover:-translate-y-0.5 hover:shadow-md hover:border-primary/30 transition-all block"
          >
            <div className="h-1 bg-primary" aria-hidden="true" />
            <div className="p-5">
              <div className="flex items-center gap-2 mb-2.5">
                {t.logo && (
                  <img
                    src={t.logo}
                    alt={`${t.name} logo`}
                    className="w-7 h-7 object-contain shrink-0"
                  />
                )}
                {t.tags?.[0] && (
                  <span className="text-[11.5px] font-mono font-semibold text-primary uppercase tracking-wider">
                    {t.tags[0]}
                  </span>
                )}
              </div>
              <div className="text-base font-semibold font-mono mb-1.5">{t.name}</div>
              <div className="text-[13.5px] text-muted-foreground mb-4 leading-normal">
                {formatMarkdown(t.intro)}
              </div>
              <span className="inline-block border rounded-full px-4 py-2 text-xs font-medium hover:bg-foreground hover:text-background hover:border-foreground transition-colors">
                Deploy →
              </span>
            </div>
          </a>
        ))}
      </div>
      <div className="text-center mt-8 text-sm text-muted-foreground">
        <Link
          href="/r"
          className="text-primary border-b border-dashed border-primary/40 hover:text-primary/80 transition-colors"
        >
          Browse all templates →
        </Link>
      </div>
    </section>
  );
};
